import { takeEvery, all, put, select } from "redux-saga/effects";
import { fetchFavourites, setUserFavourites } from "../../api/favourites";
import { getFavouriteById } from "@flow/utils/helperUtils";
import { APPLICATION_DATA_SUCCESS } from "../application/constants";
import { SET_AUTH } from "../auth/constants";
import { getUserUid } from "../auth/selectors";
import { AddToFavouritesAction, RemoveFromFavouritesAction } from "./actions";
import {
  ADD_TO_FAVOURITES,
  ADD_TO_FAVOURITES_ERROR,
  ADD_TO_FAVOURITES_SUCCESS,
  FETCH_FAVOURITES,
  FETCH_FAVOURITES_ERROR,
  FETCH_FAVOURITES_SUCCESS,
  REMOVE_FROM_FAVOURITES,
  REMOVE_FROM_FAVOURITES_ERROR,
  REMOVE_FROM_FAVOURITES_SUCCESS,
} from "./constants";
import { selectFavourites } from "./selectors";
import { SET_MY_FLOW } from "../myflow/constants";

function* doFetchFavourites() {
  try {
    const uid: string | null = yield select(getUserUid);
    if (uid) {
      const favourites = yield fetchFavourites(uid);
      if (favourites) {
        yield put({
          type: FETCH_FAVOURITES_SUCCESS,
          favourites: favourites,
        });
        const favouriteEvents: string[] = favourites.map(
          (favourite: Favourite) => {
            return favourite.events.filter(
              (eventId: string) =>
                favourite.excludedEvents.indexOf(eventId) === -1
            );
          }
        );
        const favouriteEventIds: string[] = [].concat(...favouriteEvents);
        yield put({
          type: SET_MY_FLOW,
          myFlow: favouriteEventIds,
        });
      }
    }
  } catch (error) {
    yield put({ type: FETCH_FAVOURITES_ERROR });
  }
}

function* doAddToFavourites(payload: AddToFavouritesAction) {
  try {
    const uid: string | null = yield select(getUserUid);
    const favourite = payload.favourite;
    const favourites: Favourite[] = yield select(selectFavourites);
    if (!getFavouriteById(favourites, favourite.programId)) {
      const newFavourites = favourites.concat(favourite);
      yield setUserFavourites(uid, newFavourites);
      yield put({
        type: ADD_TO_FAVOURITES_SUCCESS,
        favourites: newFavourites,
      });
    }
  } catch (error) {
    yield put({ type: ADD_TO_FAVOURITES_ERROR });
  }
}

function* doRemoveFromFavourites(payload: RemoveFromFavouritesAction) {
  try {
    const uid: string | null = yield select(getUserUid);
    const programId = payload.programId;
    const favourites: Favourite[] = yield select(selectFavourites);
    const updatedFavouritesList = favourites.filter(
      (favourite) => favourite.programId !== programId
    );
    if (favourites.length !== updatedFavouritesList.length) {
      yield setUserFavourites(uid, updatedFavouritesList);
      yield put({
        type: REMOVE_FROM_FAVOURITES_SUCCESS,
        favourites: updatedFavouritesList,
      });
    }
  } catch (error) {
    yield put({ type: REMOVE_FROM_FAVOURITES_ERROR });
  }
}

export function* favouritesWatcher() {
  yield all([
    takeEvery(FETCH_FAVOURITES, doFetchFavourites),
    takeEvery(ADD_TO_FAVOURITES, doAddToFavourites),
    takeEvery(REMOVE_FROM_FAVOURITES, doRemoveFromFavourites),
    takeEvery(SET_AUTH, doFetchFavourites),
  ]);
}



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/favourites/sagas.ts